import { Box, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

interface PrintPOProps {
    title?: string;
    date?: string;
    data: any[];
}

const PrintPO = React.forwardRef((props: PrintPOProps, ref) => {
    const [grandTotal, setGrandTotal] = useState(0);
    const calculateGrandTotal = () => {
        return props.data.reduce((accumulator, currentValue) => {
            return parseFloat(accumulator) + parseFloat(currentValue.grandTotal);
        }, 0);
    };
    useEffect(() => {
        const calculatedTotal = calculateGrandTotal();
        setGrandTotal(calculatedTotal);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data]);
    return (
        <Box ref={ref} sx={{
            margin: 0,
            width: "100%",
            borderCollapse: "collapse",
            textAlign: 'center',
            paddingLeft: '20px',
            paddingRight: '20px',
            '&@page': {
                size: 'A4 portrait',
            },
            overflow: 'hidden',
            fontSize: 8,
            display: 'block',
            pageBreakBefore: 'auto', // Allow page break before this element    
        }}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TableContainer >
                        <Table sx={{ minWidth: 650, overflow: 'hidden' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={8} sx={{ textAlign: 'center', }}>
                                        <Typography fontWeight={'bold'}>{props.title}</Typography>
                                        <Typography>{props.date}</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell width={20}>วันที่เอกสาร</TableCell>
                                    <TableCell width={300}>เลขเอกสาร</TableCell>
                                    <TableCell width={450}>ชื่อผู้ขาย</TableCell>
                                    <TableCell width={100}>ยอดรวมสุทธิ</TableCell>
                                    <TableCell width={30}>บันทึก</TableCell>
                                    <TableCell width={30}>แก้ไข</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {props?.data?.length > 0 && props?.data?.map((row: any) => (
                                    <TableRow
                                        key={row.id}
                                    >
                                        <TableCell component="th" width={100}>
                                            {dayjs(row.docDate).format('DD/MM/YYYY')}
                                        </TableCell>
                                        <TableCell width={300} style={{
                                            wordBreak: 'break-all',
                                            flexWrap: 'wrap',
                                            maxWidth: 300,
                                        }}>{row.docNo}</TableCell>
                                        <TableCell width={450}  >{row.vendor?.name}</TableCell>
                                        <TableCell width={100} align="right">{parseFloat(row.grandTotal).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</TableCell>
                                        <TableCell width={30}><span style={{ fontSize: 8 }}><Box>{<b>{row.createBy?.name}</b>}</Box> {dayjs(row.createAt).format('DD/MM/YYYY HH:mm')} </span></TableCell>
                                        <TableCell width={30}><span style={{ fontSize: 8 }}>{<b>{row.updateBy?.name}</b>} {row.updateAt ? dayjs(row.updateAt).format('DD/MM/YYYY HH:mm') : ''}</span> </TableCell>
                                    </TableRow>
                                ))}
                                {props.data.length === 0 && (
                                    <TableRow
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell colSpan={10} align="center">ไม่พบข้อมูล</TableCell>
                                    </TableRow>
                                )}
                                <TableRow>
                                    <TableCell colSpan={5} align="right"><b>จำนวนเงินรวมทั้งสิ้น</b></TableCell>
                                    <TableCell colSpan={2} align="right">{parseFloat(grandTotal.toString()).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Box >
    );
});

export default PrintPO;